import * as enterpriseTypes from "../enterprise/members/actions"
import * as accountantTypes from "../accountants/actions"
import * as subscriptionTypes from "../subscriptions/actions"

const uiInitalState = {
  createClientInvitesForm: {
    error: false,
    error_message: "",
    success: false
  },
  createMemberInvitesForm: {
    error: false,
    error_message: "",
    success: false
  },
  accountantGroupForm: {
    error: false,
    error_message: "",
    success: false
  },
  createSubscriptionForm: {
    submitting: false,
    error: false,
    error_message: "",
    success: false
  },
  updateSubscriptionForm: {
    submitting: false,
    error: false,
    error_message: "",
    success: false
  },
  updateCardForm: {
    submitting: false,
    error: false,
    error_message: "",
    success: false
  },
  cancelReactivateSubscriptionForm: {
    submitting: false,
    error: false,
    error_message: "",
    success: false
  },
  showCreateSubscriptionSuccessModal: false,
  createdAccountantGroupAlertModal: {
    showModal: false,
    modalTitle: "Profile Created!",
    modalBody: "You're all set to start inviting clients!",
    alertStyle: "success",
    okButtonTitle: "Invite Clients",
    cancelButtonTitle: "Cancel"
  }
}

export default function ui(state = uiInitalState, action) {
  switch (action.type) {
    case accountantTypes.RESET_ACCOUNTANT_GROUP_FORM:
      return Object.assign({}, state, {
        accountantGroupForm: {
          error: false,
          success: false,
          error_message: ""
        }
      })
    case accountantTypes.UPDATE_ACCOUNTANT_GROUP_SUCCESS:
      return Object.assign({}, state, {
        accountantGroupForm: {
          error: false,
          success: true,
          error_message: ""
        }
      })
    case accountantTypes.UPDATE_ACCOUNTANT_GROUP_FAILURE:
      return Object.assign({}, state, {
        accountantGroupForm: {
          error: true,
          success: false,
          error_message: action.json.base.join(", ")
        }
      })

    case accountantTypes.RESET_CREATE_CLIENT_INVITES_FORM:
      return Object.assign({}, state, {
        createClientInvitesForm: {
          error: false,
          success: false,
          error_message: ""
        }
      })
    case accountantTypes.CREATE_CLIENT_INVITES_SUCCESS:
      return Object.assign({}, state, {
        createClientInvitesForm: {
          error: false,
          success: true,
          error_message: ""
        }
      })
    case accountantTypes.CREATE_CLIENT_INVITES_FAILURE:
      return Object.assign({}, state, {
        createClientInvitesForm: {
          error: true,
          success: false,
          error_message: action.json.base.join(", ")
        }
      })

    case accountantTypes.CREATE_ACCOUNTANT_GROUP_SUCCESS:
      return Object.assign({}, state, {
        createdAccountantGroupAlertModal: {
          ...state.createdAccountantGroupAlertModal,
          showModal: true
        }
      })
    case accountantTypes.HIDE_CREATE_ACCOUNTANT_GROUP_MODAL:
      return Object.assign({}, state, {
        createdAccountantGroupAlertModal: {
          ...state.createdAccountantGroupAlertModal,
          showModal: false
        }
      })

    case subscriptionTypes.HIDE_CREATE_SUBSCRIPTION_MODAL:
      return Object.assign({}, state, {
        showCreateSubscriptionSuccessModal: false
      })
    // case subscriptionTypes.CREATE_SUBSCRIPTION_SUCCESS:
    case "SHOW_CREATE_SUB_SUCCESS_MODAL":
      return Object.assign({}, state, {
        showCreateSubscriptionSuccessModal: true
      })

    case subscriptionTypes.CREATE_SUBSCRIPTION_FORM_REQUEST:
      return Object.assign({}, state, {
        createSubscriptionForm: {
          submitting: true,
          error: false,
          success: false,
          error_message: ""
        }
      })
    case subscriptionTypes.CREATE_SUBSCRIPTION_FORM_FAILURE:
      return Object.assign({}, state, {
        createSubscriptionForm: {
          submitting: false,
          error: true,
          success: false,
          error_message:
            action.json && action.json.base ? action.json.base.join(", ") : ""
        }
      })
    case subscriptionTypes.CREATE_SUBSCRIPTION_FORM_SUCCESS:
      return Object.assign({}, state, {
        createSubscriptionForm: {
          submitting: false,
          error: false,
          success: true,
          error_message: ""
        }
      })
    case subscriptionTypes.CREATE_SUBSCRIPTION_FORM_RESET:
      return Object.assign({}, state, {
        createSubscriptionForm: {
          submitting: false,
          error: false,
          success: false,
          error_message: ""
        }
      })
      break

    case subscriptionTypes.UPDATE_CARD_FORM_REQUEST:
      return Object.assign({}, state, {
        updateCardForm: {
          submitting: true,
          error: false,
          success: false,
          error_message: ""
        }
      })
    case subscriptionTypes.UPDATE_CARD_FORM_FAILURE:
      return Object.assign({}, state, {
        updateCardForm: {
          submitting: false,
          error: true,
          success: false,
          error_message: action.json ? action.json.base.join(", ") : ""
        }
      })
    case subscriptionTypes.UPDATE_CARD_FORM_SUCCESS:
      return Object.assign({}, state, {
        updateCardForm: {
          submitting: false,
          error: false,
          success: true,
          error_message: ""
        }
      })
    case subscriptionTypes.UPDATE_CARD_FORM_RESET:
      return Object.assign({}, state, {
        updateCardForm: {
          submitting: false,
          error: false,
          success: false,
          error_message: ""
        }
      })
      break

    case subscriptionTypes.UPDATE_SUBSCRIPTION_FORM_REQUEST:
      return Object.assign({}, state, {
        updateSubscriptionForm: {
          submitting: true,
          error: false,
          success: false,
          error_message: ""
        }
      })
    case subscriptionTypes.UPDATE_SUBSCRIPTION_FORM_FAILURE:
      return Object.assign({}, state, {
        updateSubscriptionForm: {
          submitting: false,
          error: true,
          success: false,
          error_message: action.json ? action.json.base.join(", ") : ""
        }
      })
    case subscriptionTypes.UPDATE_SUBSCRIPTION_FORM_SUCCESS:
      return Object.assign({}, state, {
        updateSubscriptionForm: {
          submitting: false,
          error: false,
          success: true,
          error_message: ""
        }
      })
    case subscriptionTypes.UPDATE_SUBSCRIPTION_FORM_RESET:
      return Object.assign({}, state, {
        updateSubscriptionForm: {
          submitting: false,
          error: false,
          success: false,
          error_message: ""
        }
      })
      break

    case subscriptionTypes.CANCEL_REACTIVATE_SUBSCRIPTION_FORM_REQUEST:
      return Object.assign({}, state, {
        cancelReactivateSubscriptionForm: {
          submitting: true,
          error: false,
          success: false,
          error_message: ""
        }
      })
    case subscriptionTypes.CANCEL_REACTIVATE_SUBSCRIPTION_FORM_FAILURE:
      return Object.assign({}, state, {
        cancelReactivateSubscriptionForm: {
          submitting: false,
          error: true,
          success: false,
          error_message: action.json ? action.json.base.join(", ") : ""
        }
      })
    case subscriptionTypes.CANCEL_REACTIVATE_SUBSCRIPTION_FORM_SUCCESS:
      return Object.assign({}, state, {
        cancelReactivateSubscriptionForm: {
          submitting: false,
          error: false,
          success: true,
          error_message: ""
        }
      })
    case subscriptionTypes.CANCEL_REACTIVATE_SUBSCRIPTION_FORM_RESET:
      return Object.assign({}, state, {
        cancelReactivateSubscriptionForm: {
          submitting: false,
          error: false,
          success: false,
          error_message: ""
        }
      })
      break

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ui/reducer.js